import { Button, alpha, styled } from '@mui/material'
import { Flex, FlexCenter, FlexColumn, SectionWrap } from 'styles'
import DoneIcon from '@mui/icons-material/Done'

export const TableHead = styled(Flex)`
  height: 24px;
  align-items: center;
  color: ${({ theme }) => theme.color.text60};
  border-bottom: 1px solid rgba(43, 49, 58, 1);
  /* border-bottom: 1px solid ${({ theme }) => theme.color.text10}; */
  font-size: 12px;
  padding-right: 8px;
  font-weight: 600;
  line-height: 16px;
`
export const OpenOrdersHead = styled(TableHead)`
  position: relative;
  display: flex;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const MobileOpenOrdersHead = styled(TableHead)`
  position: relative;
  display: none;
  padding: 0 16px;
  justify-content: space-between;
  color: ${(props) => props.theme.color?.text60};
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    width: 100%;
  }
  > div {
    flex: 0 0 33%;
    justify-content: flex-end;
    &:nth-of-type(1) {
      justify-content: flex-start;
    }
  }
`
export const HistoryOrdersHead = styled(TableHead)`
  display: flex;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const MobileHistoryOrdersHead = styled(TableHead)`
  display: none;
  padding: 0 16px;
  color: ${(props) => props.theme.color?.text60};

  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    justify-content: space-between;
  }
  > div {
    flex: 0 0 33%;
    justify-content: flex-end;
    &:nth-of-type(1) {
      justify-content: flex-start;
    }
  }
`

export const TradeHistoryHead = styled(TableHead)`
  display: flex;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
`
export const MobileTradeHistoryHead = styled(TableHead)`
  display: none;
  padding: 0 16px;
  justify-content: space-between;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
  }
  > div {
    flex: 0 0 33%;
    justify-content: flex-end;
    &:nth-of-type(1) {
      justify-content: flex-start;
    }
  }
`

const TableContent = styled('div')`
  position: relative;
  flex: 1;
  flex-shrink: 0;
  flex-direction: column;
  color: ${({ theme }) => theme.color.text100};
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding-right: 8px;
  margin: 0 16px;
  overflow-y: auto;

  .user-order {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    pointer-events: none;
    min-height: unset;
    p {
      margin-top: 30px;
    }
  }
`
export const OpenOrdersContent = styled(TableContent)``
export const HistoryOrderContent = styled(TableContent)``
export const TradeHistoryContent = styled(TableContent)``

export const TableContentRow = styled(Flex)`
  width: 100%;
  height: 100%;
  align-items: center;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: none;
  }
  &:hover {
    background: ${({ theme }) => alpha(theme.color.text20, 0.5)};
  }
`
export const MobileTableContentRow = styled(Flex)`
  /* padding: 16px; */
  padding: 0 16px;
  align-items: center;
  display: none;
  height: 36px;
  width: 100%;
  ${(props) => props.theme.breakpoints.down('md')} {
    display: flex;
    background: ${(props) => props.theme.color?.bg};
    border-bottom: 1px solid ${(props) => props.theme.color?.text10};
    .sub {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      text-align: right;
      color: ${(props) => props.theme.color?.text60};
    }
    .title {
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: ${(props) => props.theme.color?.text90};
    }
  }
`
export const TableCell = styled(Flex)`
  padding-left: 12px;
  flex-wrap: wrap;
`
export const Time = styled(TableCell)`
  color: ${(props) => props.theme.color?.text90};
`
export const Side = styled(TableCell)`
  .buy {
    color: ${(props) => props.theme.color?.buy30};
  }
  .sell {
    color: ${(props) => props.theme.color?.sell30};
  }
`
export const OpenTime = styled(Time)`
  width: 15%;
`
export const OpenMarket = styled(TableCell)`
  width: 10%;
`
export const OpenType = styled(TableCell)`
  width: 9%;
`
export const OpenSide = styled(Side)`
  width: 5%;
  .buy {
    color: ${(props) => props.theme.color?.buy30};
  }
  .sell {
    color: ${(props) => props.theme.color?.sell30};
  }
`
export const OpenSize = styled(TableCell)`
  width: 12%;
  ${(props) => props.theme.breakpoints.down('md')} {
    flex: 0 0 12%;
    justify-content: flex-end;
    &:first-of-type {
      justify-content: flex-start;
      padding: 0;
    }
  }
`
export const OpenPrice = styled(TableCell)`
  width: 12%;
`
export const OpenFilled = styled(TableCell)`
  width: 13%;
`
export const OpenValue = styled(TableCell)`
  width: 9.5%;
`
export const OpenCancel = styled(TableCell)`
  flex: 1;
  padding: 0 12px 0 0;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
  width: 25%;
  flex-wrap: nowrap;
  gap: 4px;
  &:hover {
    color: ${(props) => props.theme.color?.sell40};
  }
  &.disabled {
    color: ${(props) => props.theme.color?.text70};
    cursor: initial;
  }
`
export const ClosePositionCell = styled(TableCell)`
  gap: 8px;
  flex: 1;
  justify-content: flex-end;
`
export const HistoryOrderTime = styled(Time)`
  width: 15%;
`
export const HistoryOrderMarket = styled(TableCell)`
  width: 11%;
`
export const HistoryOrderType = styled(TableCell)`
  width: 9%;
`
export const HistoryOrderSide = styled(Side)`
  width: 6%;
`
export const HistoryOrderFilled = styled(TableCell)`
  width: 22.5%;
`
export const HistoryOrderAvgPrice = styled(TableCell)`
  width: 12%;
`
export const HistoryOrderPrice = styled(TableCell)`
  width: 14%;
`
export const HistoryOrderStatus = styled(TableCell)`
  flex: 1;
  font-weight: 600;
  span {
    margin-left: 4px;
  }
  .new,
  .disposed {
    color: ${(props) => props.theme.color?.notificationYellow02};
  }
  .open {
    color: ${(props) => props.theme.color?.notificationGreen02};
  }
  .filled {
    color: ${(props) => props.theme.color?.notificationGreen02};
  }
  .cancelled {
    color: ${(props) => props.theme.color?.text50};
  }
  .dismissed {
    color: ${(props) => props.theme.color?.notificationRed02};
  }
  .cancelling,
  .dismissing {
    color: ${(props) => props.theme.color?.notificationRed02};
  }
  .confirming {
    color: ${(props) => props.theme.color?.notificationBlue02};
  }
  .partial-fill {
    color: ${(props) => props.theme.color?.notificationPurple02};
  }
`
export const TradeHistoryTime = styled(Time)`
  width: 15%;
`
export const TradeHistoryMarket = styled(TableCell)`
  width: 11%;
`
export const TradeHistorySide = styled(Side)`
  width: 10%;
`
export const TradeHistorySize = styled(TableCell)`
  width: 10%;
`
export const TradeHistoryPrice = styled(TableCell)`
  width: 12%;
`
export const TradeHistoryFee = styled(TableCell)`
  width: 13%;
`
export const TradeHistoryValue = styled(TableCell)`
  width: 15%;
`
export const TradeHistoryTxHash = styled(TableCell)`
  flex: 1;
  &.content {
    cursor: pointer;
    color: ${(props) => props.theme.color?.textHighlight};
  }
`

export const MobileHeaderItem = styled(FlexCenter)`
  // width: 33px;
  height: 100%;
  color: ${(props) => props.theme.color.text60};
  span {
    margin: 0 4px;
  }
`
export const CoinInfo = styled(FlexCenter)`
  width: 33%;
`
export const CoinIcon = styled(Flex)`
  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin-right: 8px;
  }
`
export const CoinData = styled(FlexColumn)``
export const CoinSize = styled(Flex)`
  align-items: flex-end;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  padding-bottom: 2px;
  &.buy {
    color: ${(props) => props.theme.color.buy30};
  }
  &.sell {
    color: ${(props) => props.theme.color.sell30};
  }

  small {
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    margin-left: 2px;
    color: ${(props) => props.theme.color.text40};
  }
`
export const CoinName = styled(Flex)`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text60};
`
export const CoinPrice = styled(FlexColumn)`
  align-items: flex-end;
  flex: 0 0 33%;
`
export const CoinFilled = styled(FlexColumn)`
  align-items: flex-end;
`
export const HistoryOrdersWrap = styled(FlexColumn)`
  width: 100%;
  height: 100%;

  ${(props) => props.theme.breakpoints.up('md')} {
    overflow: auto;
  }

  ${(props) => props.theme.breakpoints.down('md')} {
    height: 300px;
  }
`
export const LoadWrap = styled(FlexCenter)`
  height: 44px;
  gap: 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.color.text60};
  background-color: ${(props) => props.theme.color.bg} !important;
`
export const LoadText = styled(Flex)``
export const LoadBtn = styled(FlexCenter)`
  height: 24px;
  padding: 6px 8px;
  color: ${(props) => props.theme.color.text90};
  border: 1px solid ${(props) => props.theme.color.primary30};
  border-radius: 20px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => props.theme.color.primary20};
    border: 1px solid ${(props) => props.theme.color.primary20};
    color: ${(props) => props.theme.color.text00};
  }
`
export const BotsTime = styled(Time)`
  width: 10%;
  color: ${(props) => props.theme.color?.text90};
`
export const BotsMarket = styled(TableCell)`
  width: 10%;
  &.link {
    cursor: pointer;
    color: ${(props) => props.theme.color?.primary30};
  }
`
export const BotsType = styled(TableCell)`
  width: 9%;
`
export const BotsSide = styled(Side)`
  width: 5%;
  .buy {
    color: ${(props) => props.theme.color?.buy30};
  }
  .sell {
    color: ${(props) => props.theme.color?.sell30};
  }
`
export const BotsPrice = styled(TableCell)`
  width: 12%;
`
export const BotsExposedSize = styled(TableCell)`
  width: 12%;
`
export const BotsFilled = styled(TableCell)`
  width: 20%;
`
export const BotsValue = styled(TableCell)`
  width: 15%;
`

export const OrdersWrap = styled(SectionWrap)`
  flex: 1;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 300px;
  height: 100%;

  ${(props) => props.theme.breakpoints.down('md')} {
    border-top: none;
    border-bottom: none;

    overflow: hidden;
    width: 100%;
    margin-top: unset;
    border-radius: unset;
    flex: unset;
    height: 500px;
  }
`
export const TitleWrap = styled('div')`
  display: flex;
  align-items: center;

  ${(props) => props.theme.breakpoints.down('md')} {
    flex-wrap: wrap;
    background: ${(props) => props.theme.color.bgGray};
  }
`
export const OrderTitleItem = styled('div')`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.color.text50};
  cursor: pointer;
  user-select: none;

  ${(props) => props.theme.breakpoints.down('md')} {
    height: 36px;
    flex: 1 0 0;
    padding: 0;
    justify-content: center;
    border-bottom: 1px solid ${(props) => props.theme.color.text20};
    border-top: 1px solid ${(props) => props.theme.color.text20};
    border-right: 1px solid ${(props) => props.theme.color.text20};

    &:nth-of-type(4) {
      border-right: none;
    }
  }

  &.active {
    color: ${({ theme }) => theme.color.text100};
    font-weight: 600;
  }
  &:hover {
    color: ${({ theme }) => theme.color.text100};
  }
`
export const OrderTitleTab = styled(Flex)``
export const OrderTitleFlag = styled(Flex)`
  width: 6px;
  height: 6px;
  margin: -2px 0 0 2px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.color.sell40};
`
export const OrderOtherWrap = styled(Flex)`
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin-right: 10px;
  display: flex;
  ${(props) => props.theme.breakpoints.down('md')} {
    flex: unset;
    width: 100%;
    height: 32px;
    margin-right: unset;
    margin: 8px 16px 0;
    justify-content: space-between;
    border-bottom: 1px solid rgba(46, 54, 59, 1);
  }
`
export const CheckWrap = styled(Flex)`
  align-items: center;
  gap: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  cursor: pointer;
  &:hover {
    .checkbox-border {
      border: 1px solid ${(props) => props.theme.color.primary30};
    }
  }
`
export const CheckBoxPair = styled(Flex)<{
  checked?: boolean
}>`
  width: 12px;
  height: 12px;
  justify-content: center;
  align-items: center;
  color: ${(props) =>
    props.checked ? props.theme.color.primary30 : props.theme.color.text50};
  border: 1px solid
    ${(props) =>
      props.checked ? props.theme.color.primary30 : props.theme.color.text50};
  input {
    position: absolute;
    z-index: -1;
    width: 1px;
    height: 1px;
  }
`
export const CheckLabel = styled('div')`
  color: ${(props) => props.theme.color.text50};
  user-select: none;
`
export const TriggerDone = styled(DoneIcon)`
  color: ${(props) => props.theme.color.notificationGreen02};
  font-size: 12px;
`

export const StyledColumn = styled(FlexColumn)`
  align-items: flex-start;
  .title {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.theme.color?.text90};
    text-align: right;
  }
  .sub {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    text-align: right;
    color: ${(props) => props.theme.color?.text60};
  }
`

export const SymbolLink = styled(Flex)`
  display: flex;
  align-items: center;
  cursor: pointer;
  svg {
    display: none;
  }
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    svg {
      margin-left: 2px;
      display: block;
    }
  }
`

export const StyledEndItem = styled('div')`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`

export const MobileCardWrap = styled('div')`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 0 16px;
  padding-top: 16px;
  padding-bottom: 20px;

  gap: 16px;
  border-bottom: 1px solid #2e363b;
`

export const MobileColumnItem = styled('div')<{ flex?: string }>`
  display: flex;
  flex-direction: column;
  flex: ${(props) => (props.flex ? props.flex : 1)};

  &.last {
    align-items: flex-end;
  }
`

export const MobileItemTitle = styled('span')`
  font-size: 12px;
  color: #7b8891;
  line-height: 18px;
`

export const MobileItemData = styled('span')`
  font-size: 14px;
  color: #e5eaee;
  margin-top: 4px;
  line-height: 20px;
  &.hash {
    color: rgba(68, 143, 255, 1);
  }
`

export const MobileItem = styled('p')`
  font-size: 14px;
  color: #e5eaee;
`

export const MobileItemFlex = styled('div')`
  display: flex;
`
export const MobileButtonGroup = styled('div')`
  display: flex;
  gap: 24px;
`
export const MobileCancelButton = styled(Button)`
  flex: 1;
  height: 32px;
  color: rgba(160, 238, 9, 1);
  font-size: 14px;
  background-color: rgba(42, 49, 57, 1);
  border-radius: 16px;
`
